import React from "react";
import { executeQuery } from "../../requests/executeQuery";
import { STRIVE_FEES } from "../../consts/queries";
import { FeesPipeline } from "./FeesPipeline";
import dollars from "../../dollar-format";
import { columns, printFirstColumns, printSecondColumns } from "./columns";
import Input from "../Input";
import transactionTypes from "../../transaction-types";
import { Chip, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import SelectTeam from "../SelectTeam/SelectTeam";
import filter from "../../filter";
import {
  calculateTotalColumn,
  formatName,
  formatNames,
  getNotEmptyValueCount,
  renderPrintFooter,
} from "../../utils";
import { getData } from "../../requests/CRUD";
import { Link } from "react-router";
import { TEAM } from "../../consts/tables";
import { ApolloConsumer } from "@apollo/client";
import {
  GET_ALL_TEAM_MEMBERS_DATA,
  GET_TEAMMEMBER_StRIVE_FEES,
  STRIVE_FEES_QUERY,
} from "../Graphql/Queries/StriveFeesQuery";
import { fetchData } from "../Service/graphQlService";
import { GET_CONTACT_TEAM_BY_ARCIMEDES_ID, GET_CONTACT_TEAM_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import propertyCategories from "../../property-categories";
import propertyTypes from "../../property-types";
import propertySide from "../../property-side";

const noPropertiesPerPage = 12;

export default class StriveFees extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: [],
      query: {
        SOURCE: "STRIVE,External",
        START_DATE: `01/01/${new Date().getFullYear()}`,
        END_DATE: new Date().toLocaleDateString("en-US"),
        TRANSACTION_TYPE:
          "Investment Sales,Leasing,Financing,Advisory,Referral",
        AGENT_ID: "",
        order: "CLOSE_OF_ESCROW.asc",
        CATEGORY: null,
        TYPE: null,
        SIDE: 'ALL'
      },
      agentName: "",
      isPrint: false,
      printBackground: "",
    };
    this.client = null;
    this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.beforePrint = this.beforePrint.bind(this);
    this.afterPrint = this.afterPrint.bind(this);
    this.handleSideChangeDropdown = this.handleSideChangeDropdown.bind(this);
    this.getSideValuesForDropdown = this.getSideValuesForDropdown.bind(this);
    this.convertAgentIds = this.convertAgentIds.bind(this)
  }

  componentDidMount() {
    this.setState(
      {
        printBackground: `url('${
          arc.path.media + "Transaction_Background.png"
        }')`,
      },
      this.fetch
    );
    window.onbeforeprint = this.beforePrint;
    window.onafterprint = this.afterPrint;
  }

  beforePrint() {
    this.setState({ isPrint: true });
  }

  afterPrint() {
    this.setState({ isPrint: false });
  }
  convertAgentIds(data) {
    for (let i = 1; i <= 4; i++) {
      const key = `AGENT_ID_${i}`;
      const value = data[key];
      data[key] = Number.isInteger(+value) && !isNaN(+value) ? parseInt(value, 10) : null;
    }
    return data;
  }

  fetch() {
    let query = { ...this.state.query };
    // let query = cloneDeep(this.state.query);
    if(query.hasOwnProperty("AGENT_ID") && (query.AGENT_ID === null || query.AGENT_ID === "")){
        delete query.SIDE
    }
    query = filter(query, "striveFees");
    const token = localStorage.getItem("authToken");
    const agentOptions = {
      limit: {
        count: 1,
        offset: 0,
      },
      column: ["FIRST_NAME", "LAST_NAME"],
      filter: [
        {
          code: "ARCIMEDES_ROW_ID",
          text: this.state.query.AGENT_ID,
          type: "exact",
        },
      ],
    };
    

    if (this.client) {
      const variableData = query.param ? query.param : {};
      const updatedData = this.convertAgentIds(variableData);
    //   if (variableData.hasOwnProperty("AGENT_ID")) {
    //     variableData["AGENT_ID_1"] = parseInt(variableData["AGENT_ID","AGENT_ID_1","AGENT_ID_2","AGENT_ID_3","AGENT_ID_4"], 10);
    //     // variableData["SIDE"] = "ALL"
    //     // delete variableData["AGENT_ID"];
    // }
      const agent_id = this.state.query.AGENT_ID
        ? this.state.query.AGENT_ID : "";
      // const TeamQuery = agent_id ? GET_TEAMMEMBER_StRIVE_FEES : GET_ALL_TEAM_MEMBERS_DATA
      const TeamQuery = agent_id ? GET_CONTACT_TEAM_BY_ARCIMEDES_ID : GET_CONTACT_TEAM_LIST_QUERY
      // const teamVariableData = agent_id ? {arcimedesRowId :agent_id} : {filters:[]}
      const teamVariableData = agent_id ? {arcimedes_row_id : parseInt(agent_id)} : {type:"Team",filters:[]}

      function getCapitalizedContact(contact) {
        if (!contact || Object.keys(contact).length === 0) {
          return [];
        }
      
        return [
          {
            ...Object.fromEntries(
              Object.entries(contact).map(([key, value]) => [key, value])
            )
          }
        ];
      }
      Promise.all([
        //     // executeQuery({queryName: STRIVE_FEES, options: query}),
        //     // getData({tableCode: TEAM, options: agentOptions})
        // this.client.query({
        //   query: STRIVE_FEES_QUERY,
        //   variables: { params: variableData },
        //   fetchPolicy: "no-cache",
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`, // Bearer token added here
        //     },
        //   },
        // }),
        // this.client.query({
        //   query: TeamQuery,
        //   variables: teamVariableData,
        //   fetchPolicy: "no-cache",
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,
        //     },
        //   },
        // }),

        fetchData( STRIVE_FEES_QUERY,
          { params: updatedData }),
        fetchData( TeamQuery,
        teamVariableData),
      ])
        .then((res) => {
          if (
            res &&
            res[0] &&
            res[0].data.striveFees.success &&
            Array.isArray(res[0].data.striveFees.data)
          ) {
      
            // Convert keys to uppercase and wrap in an array
            const capitalizedContact = res[1] && res[1].data.getContactByContactid && getCapitalizedContact(res[1].data.getContactByContactid.contact);
            const rows = res[0].data.striveFees.data.map((data, index) => {
              return new FeesPipeline(
                data,
                index + 1,
                false,
                // res[1].data.getAllTeamMembers ? res[1].data.getAllTeamMembers : res[1].data.getTeamMember
                res[1].data && res[1].data.getContacts && res[1].data.getContacts.data ? res[1].data.getContacts.data : capitalizedContact,
                false
              );
            }); 
            if(rows.length>0){
              const striveFee = calculateTotalColumn(rows, 'striveFee');
              const no_non_empty_transactions = getNotEmptyValueCount(rows, "striveFee");
              rows[rows.length] = new FeesPipeline({
                  TOTAL_FEE: calculateTotalColumn(rows, 'totalFee'),
                  STRIVE_FEE: striveFee,
                  AGENT_FEE: calculateTotalColumn(rows, 'agentFee'),
                  LISTING_AGENT1_TOTAL_FEE: calculateTotalColumn(rows, 'listingAgent1Price'),
                  LISTING_AGENT2_TOTAL_FEE: calculateTotalColumn(rows, 'listingAgent2Price'),
                  LISTING_AGENT3_TOTAL_FEE: calculateTotalColumn(rows, 'listingAgent3Price'),
                  LISTING_AGENT4_TOTAL_FEE: calculateTotalColumn(rows, 'listingAgent4Price'),
                  BUYER_AGENT1_TOTAL_FEE: calculateTotalColumn(rows, 'buyerAgent1Price'),
                  BUYER_AGENT2_TOTAL_FEE: calculateTotalColumn(rows, 'buyerAgent2Price'),
                  BUYER_AGENT3_TOTAL_FEE: calculateTotalColumn(rows, 'buyerAgent3Price'),
                  BUYER_AGENT4_TOTAL_FEE: calculateTotalColumn(rows, 'buyerAgent4Price'),
                  TRANSACTION_TYPE: "Total:"
              }, null, true, [], false);
              
              rows[rows.length] = new FeesPipeline({
                NO_OF_TRANSACTIONS: res[0].data.striveFees.data.length,
                TRANSACTION_TYPE: "# of Trans:"
            }, null, false, [], true);

            rows[rows.length] = new FeesPipeline({
                STRIVE_FEE: striveFee,
                NO_OF_TRANSACTIONS: no_non_empty_transactions,
                TRANSACTION_TYPE: "Ave/Tran:"
            }, null, false, [], true);
        }
            const state = {
              rows,
            };
            // if (
            //   res[1] &&
            //   // Array.isArray(res[1].data.getAllTeamMembers) || 
            //   // res[1].data.getTeamMember
            // )
            if (
              res[1] &&
              (
                (res[1].data && res[1].data.getContacts && Array.isArray(res[1].data.getContacts.data)) ||
                (res[1].data && res[1].data.getContactByContactid && res[1].data.getContactByContactid.success)
              )
            )
             {
              // state.agentName = Array.isArray(res[1].data.getAllTeamMembers) ? formatNames(res[1].data.getAllTeamMembers[0]) : formatNames(res[1].data.getTeamMember);
              const contacts = res[1] && res[1].data && res[1].data.getContacts && res[1].data.getContacts.data;
              const contactById = res[1] && res[1].data && res[1].data.getContactByContactid && capitalizedContact
              state.agentName = Array.isArray(contacts)
                ? formatNames(contacts[0])
                : formatNames(contactById);
            } //to remove the selected AgentName if we click on the unselect(X) button
            else if (res[1] && !res[1].success) {
              state.agentName = "";
            }
            const agentIndex = columns.filter((e) => e.key === "agentFee");
            if (query.param.AGENT_ID && agentIndex.length < 1) {
              columns.push({
                name: "Agent Fee",
                subName: "(Gross Fee)",
                key: "agentFee",
                class: "Fees_column_numeric",
                format: "$",
                withCents: true,
              });
              printSecondColumns.push(columns[10]);
            } else {
              if (!query.param.AGENT_ID && agentIndex.length >= 1) {
                columns.splice(
                  columns.findIndex((e) => e.key === "agentFee"),
                  1
                );
                printSecondColumns.pop(columns[10]);
              }
            }
            this.setState(state);
          }
        })
        .catch((err) => {
          this.setState({
            error: err.message,
            isBusy: null,
          });
        });
    }
  }

  getValuesForDropdown(query, options, key, type = "multiple") {
    if (!query || !options || !options.length) return [];
    let formattedQueryValues;
    if (query.arcimedes_row_id) {
      formattedQueryValues = query.arcimedes_row_id;
    } else {
      formattedQueryValues = query.split(",");;
    }
    let response = [];

    options.forEach((el) => {
      if (!key) {
        if (formattedQueryValues.includes(el)) {
          response.push(el);
        }
      } else {
        if (formattedQueryValues.includes(String(el[key]))) {
          response.push(el);
        }
      }
    });

    if (!response) return [];
    if (type === "multiple") return response;
    return response[0];
  }

  handleChangeDropdown(
    event,
    reason,
    queryType,
    dropdownType = "single",
    key = null
  ) {
    const query = { ...this.state.query };
    if (!reason) {
      query[queryType] = null;
    } else {
      if (dropdownType === "single") {
        if (!key) query[queryType] = reason;
        else query[queryType] = reason[key];
      } else {
        let result = "";
        reason.forEach((el) => {
          if (!key) result += el + ",";
          else result += el[key] + ",";
        });
        if((queryType === "AGENT_ID" && result.split(",").length<=5) || queryType !== "AGENT_ID"){
          query[queryType] = result;
      }
      }
    }

    this.setState({ query });
  }

  getSideValuesForDropdown() {
    const {SIDE} = this.state.query
    if( SIDE == 'ALL'){
        return null
    }else if(SIDE == 'LISTING_AGENT_4_FIRM'){
        return propertySide[0]
    }else if(SIDE == 'BUYER_AGENT_4_FIRM'){
        return propertySide[1]
    }
}

handleSideChangeDropdown(e, value){
    const query = {...this.state.query};
    if(value == null){
        query.SIDE = 'ALL'
    }else if(value.code === "listside"){
        query.SIDE = 'LISTING_AGENT_4_FIRM'
    }else if(value.code === "buyside"){
        query.SIDE = 'BUYER_AGENT_4_FIRM'
    }
    this.setState({query});
}

  handleChange(e) {
    const query = { ...this.state.query };
    query[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ query });
  }

  onSubmit() {
    this.fetch();
  }

  static renderCell({row, index, column, isCustom=false}) {
    let value = '';
    if (row[column.key]) {
        if (column.format === '$' && row['transactionType'] !== "# of Trans:") {
            const withCents = column.withCents;
            value = dollars(row[column.key], withCents);
        } else if (column.format === '%') {
            value = `${row[column.key].toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
        } else {
            value = row[column.key];
        }
    }

  //   return (
  //     <td
  //       key={index + "-" + column.key}
  //       className={`${isCustom ? 'Fees_footer' : 'Fees_td'} ${column.class ? column.class : ''}`}
  //     >
  //       {/* {
  //                   column.key === 'name' ?
  //                       <Link to={{pathname: '/property/' + row.id}}>
  //                           {value}
  //                       </Link>
  //                       :
  //                       <React.Fragment>{value}</React.Fragment>
  //               } */}
  //       {column.key === "name" ? (
  //         <Link to={{ pathname: "/property/" + row.id }}>
  //           {value.length > 22 ? value.substring(0, 22) + "..." : value}
  //         </Link>
  //       ) : column.key === "transactionType" ? (
  //         <React.Fragment>
  //           {value == "Investment Sales" ? (value = "Sale") : "Ref"}
  //         </React.Fragment>
  //       ) : column.key === "buyerAgent1" ? (
  //         <React.Fragment>
  //           {value === "Outside Agent" ? (value = "OA") : value}
  //         </React.Fragment>
  //       ) : (
  //         <React.Fragment>{value}</React.Fragment>
  //       )}
  //     </td>
  //   );
  // }
    
  return (
    <td key={index+'-'+column.key} className={`${isCustom ? 'Fees_footer' : 'Fees_td'} ${column.class ? column.class : ''}`}>
        {/* {
            column.key === 'name' ?
                <Link to={{pathname: '/property/' + row.id}}>
                    {value}
                </Link>
                :
                <React.Fragment>{value}</React.Fragment>
        } */}
        {
            column.key === 'name' ?
                <Link to={{ pathname: '/property/' + row.id , state: { fromListUrl: window.location.pathname + window.location.search }}}>
                    {value.length > 22 ? value.substring(0, 22) + '...' : value}
                </Link>
                : column.key === "transactionType" ?
                    <React.Fragment>{value == "Investment Sales" ? value = "Sale" : isCustom ? value:"Ref"}</React.Fragment>
                    : <React.Fragment>{value}</React.Fragment>
        }
    </td>
);
}
  renderTable(columns, rows, className, isLastTable = null) {
    const hasSubColumns = true;
    const lastIndex = isLastTable || isLastTable === null ? [rows.length - 1, rows.length - 2, rows.length - 3] : [];
    return (
      <table className={className}>
        <thead>
          <tr>
            {columns.map((column, index) => {
              const subColsNo = column.subColumns
                ? column.subColumns.length
                : 1;
              return (
                <th
                  key={index}
                  className={`Fees_th ${
                    column.subColumns ? "has-subcolumn" : ""
                  }`}
                  rowSpan={column.subColumns ? 1 : 2}
                  colSpan={column.subColumns ? subColsNo : 1}
                >
                  {column.name}
                  {column.subName && (
                    <span>
                      <br /> {column.subName}
                    </span>
                  )}
                </th>
              );
            })}
          </tr>
          {hasSubColumns ? (
            <tr>
              {columns.map((column, index) => {
                if (column.subColumns) {
                  return column.subColumns.map((subColumn, subColIndex) => {
                    return (
                      <th
                        key={index + subColIndex}
                        className="Fees_th subcolumn"
                      >
                        {subColumn.name}
                      </th>
                    );
                  });
                }
              })}
            </tr>
          ) : null}
        </thead>
        <tbody>
          {rows.map((row, index) => {
            return (
              <tr key={index}>
                {columns.map((column) => {
                  if (column.subColumns) {
                    return column.subColumns.map((subCol) => {
                      return StriveFees.renderCell({row, index, column: subCol, isCustom: lastIndex.includes(index)});
                    });
                  }
                  return StriveFees.renderCell({row, index, column, isCustom: lastIndex.includes(index)});
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderPrintPages({
    rows,
    startDate,
    date,
    propertyNo,
    agentName,
    isPrint,
    printBackground,
  }) {
    let pageIndex = 0;
    const noTables = Math.ceil(rows.length / noPropertiesPerPage);

    return [...Array(noTables)].map((value, index) => {
      const isLastTable = noTables === index + 1;
      const properties = rows.slice(pageIndex, pageIndex + noPropertiesPerPage);
      pageIndex += noPropertiesPerPage;

      return [printFirstColumns, printSecondColumns].map((cols, colsIndex) => {
        return (
          <div
            className="print-container"
            key={`${index}-${colsIndex}`}
            style={{ backgroundImage: isPrint && printBackground }}
          >
            <div className="Fees_head_left" style={{ marginBottom: 20 }}>
              <h4 className="Fees_h3">STRIVE Fees</h4>
              <h4 className="Fees_h4">
                {startDate} - {date}
              </h4>
              {/* <h4 className="Fees_h4">{agentName ? agentName : "STRIVE"}</h4> */} // confirm with chisti 
              <h4 className='Fees_h4'>STRIVE</h4>
              <h4 className="Fees_h4">{propertyNo} Properties Closed</h4>
            </div>
            {this.renderTable(cols, properties, null, isLastTable)}
            {renderPrintFooter(isPrint)}
          </div>
        );
      });
    });
  }

  render() {
    const d = new Date();
    const date = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
    const { rows, query, agentName, isPrint, printBackground } = this.state;
    // const propertyNo = calculateTotalColumn(rows, null, true) - 1; // without the total row
      const propertyNo = rows.length > 0 ? calculateTotalColumn(rows, null, true) - 3 : 0;  // without the total/avg row
    const startDate = query.START_DATE;
    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) {
            this.client = client;
            this.fetch(this.props.location.query);
          }
          return (
            <div className="Fees">
              <div
                className="preload-print-background"
                style={{ backgroundImage: printBackground }}
              />
              {/* {this.renderPrintPages({columns, rows, date, propertyNo, agentName, isPrint, printBackground})} */}
              {this.renderPrintPages({
                columns,
                rows,
                startDate,
                date,
                propertyNo,
                agentName,
                isPrint,
                printBackground,
              })}

              <div className="Fees_head">
                <div className="Fees_head_left">
                  <h4 className="Fees_h3">STRIVE Fees</h4>
                  <h4 className="Fees_h4">
                    {query.START_DATE} - {query.END_DATE}
                  </h4>
                  {/* <h4 className="Fees_h5">
                    {agentName ? agentName : "STRIVE"}
                  </h4> */}
                     <h4 className='Fees_h4'>STRIVE</h4>
                  <h4 className="Fees_h5">
                    {propertyNo !== -1 ? propertyNo : 0} Properties Closed
                  </h4>
                  <button className="Fees_apply" onClick={this.onSubmit}>
                    Apply
                  </button>
                </div>
                <div className="Fees_head_right">
                  <Input
                    name="START_DATE"
                    value={query.START_DATE}
                    label="Start Date"
                    onChange={this.handleChange}
                    placeholder="MM/DD/YYYY"
                   pattern="(0?[1-9]|1[0-2])/(0?[1-9]|[12][0-9]|3[01])/((?:1|2)\d{3})"
                  />
                  <Input
                    name="END_DATE"
                    value={query.END_DATE}
                    label="End date"
                    onChange={this.handleChange}
                    placeholder="MM/DD/YYYY"
                   pattern="(0?[1-9]|1[0-2])/(0?[1-9]|[12][0-9]|3[01])/((?:1|2)\d{3})"
                  />
                  {/* <SelectTeam
                    theme="white-old agent"
                    name="AGENT_ID"
                    value={query.AGENT_ID}
                    onChange={this.handleChangeDropdown}
                    label="AGENT"
                    getValue={this.getValuesForDropdown}
                  /> */}
                  <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertyCategories}
                            value={this.getValuesForDropdown(query.CATEGORY, propertyCategories, 'code', 'single')}
                            renderInput={(params) => <TextField {...params} label='Category' variant="outlined" />}
                            onChange={(event, reason) => {this.handleChangeDropdown(event, reason, 'CATEGORY', 'single', 'code')}}
                        />
                           <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertyTypes}
                            value={this.getValuesForDropdown(query.TYPE, propertyTypes, 'code', 'single')}
                            renderInput={(params) => <TextField {...params} label='Type' variant="outlined" />}
                            onChange={(event, reason) => {this.handleChangeDropdown(event, reason, 'TYPE', 'single', 'code')}}
                        />
                        <Autocomplete
                            className='white-old single-select'
                            fullWidth	style={{marginBottom: '10px'}}
                            getOptionLabel={(option) => {
                                let result = '';
                                if (option && option.length !== 0) {
                                    result = option.name;
                                }
                                return result;
                            }}
                            options={propertySide}
                            value={this.getSideValuesForDropdown()}
                            renderInput={(params) => <TextField {...params} label='Side' variant="outlined" />}
                            onChange={(event, reason) => {this.handleSideChangeDropdown(event, reason)}}
                        />
                        <SelectTeam theme='white-old agent'
                                    name='AGENT_ID'
                                    value={query.AGENT_ID}
                                    onChange={this.handleChangeDropdown}
                                    label='AGENT'
                                    getValue={this.getValuesForDropdown}
                                    dropdownType={'multiple'}
                                    onlyAgents={true}
                        />
                  <Autocomplete
                    multiple
                    className={"white-old transaction-type"}
                    options={transactionTypes}
                    value={this.getValuesForDropdown(
                      query.TRANSACTION_TYPE,
                      transactionTypes,
                      null,
                      "multiple"
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Transaction Type"
                        variant="outlined"
                      />
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          key={index}
                          {...getTagProps({ index })}
                          label={option[0]}
                        />
                      ))
                    }
                    onChange={(event, reason) =>
                      this.handleChangeDropdown(
                        event,
                        reason,
                        "TRANSACTION_TYPE",
                        "multiple"
                      )
                    }
                  />
                </div>
              </div>
              {this.renderTable(columns, rows, "screen-table")}
            </div>
          );
        }}
      </ApolloConsumer>
    );
  }
}
